import {ChangeDetectorRef, Component, forwardRef, Input} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractNumericInput} from "../abstract-numeric-input";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIEditNumericInputComponent),
            multi: true
        }
    ],
    selector: "fui-edit-numeric-input",
    styleUrls: ["./edit-numeric-input.component.scss"],
    templateUrl: "./edit-numeric-input.component.html"
})
export class FUIEditNumericInputComponent extends FUIAbstractNumericInput {
    @Input() showClear: boolean = false;

    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }

    public clear(event: Event) {
        this.value = null;
        event.stopPropagation();
    }
}
